<script lang="ts">
import Multiselect from "vue-multiselect";
import validateForm from "@/views/tourism/mixins/validateForm";
import axios from "axios";

export default {
  name: "AddressForm",
  components: {Multiselect},
  mixins:[validateForm],
  model: {
    prop: 'payer',
    event: 'change',
  },
  props: {
    payer: Object,
    submitCheck: Boolean,
  },
  data() {
    return {
      citiesOptions: [],
    }
  },
  methods: {
    searchCities(query) {
      if (query.length > 1) {
        this.fetchCities(query);
      }
    },
    fetchCities(query) {
      axios.get('/api/directories/cities/find?city=' + query).then(({data}) => {
        this.cities = data.data;
        this.citiesOptions = data.data;

        if (this.citiesOptions.length === 0) {
          this.citiesOptions.push(this.otherCity);
        }
      }).catch(err => (console.log(err)));
    },
  }
}
</script>

<template>
  <div class="col-12">
    <div class="row">
      <div class="col-lg-12">
        <h3 class="mt">
          <span>Адреса реєстрації страхувальника</span>
        </h3>
      </div>
      <div class="col-lg-12 row passport-row">
        <div class="col-lg-6">
          <div class="form-group">
            <label for="payer-city">Місто реєстрації *</label>
            <multiselect
              id="payer-city"
              :class="['form-control', 'choice_city', {invalid: (!$v.payer.city.required && submitCheck)}]"
              v-model="payer.city"
              :options="citiesOptions"
              placeholder="Введіть назву міста"
              @search-change="searchCities"
              :internal-search="false"
              :max-height="165"
              :options-limit="300"
              :allow-empty="false"
              label="name_full_name_ua">
            </multiselect>
            <small class="error"
                   v-if="!$v.payer.city.required && submitCheck">Вкажіть
              місто прописки</small>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="form-group">
            <label for="payer-street">Вулиця *</label>
            <input v-model="payer.street"
                   id="payer-street"
                   type="text"
                   placeholder="Вул."
                   :class="['form-control', {invalid: ((!$v.payer.street.required && submitCheck) || (!$v.payer.street.customMinLength))}]">
            <small class="error" v-if="!$v.payer.street.customMinLength">Вкажіть
              вулицю мін. 4 літер</small>
            <small class="error"
                   v-if="!$v.payer.street.required && submitCheck">Вкажіть
              вулицю</small>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="form-group">
            <label for="payer-house">Будинок *</label>
            <input v-model="payer.house"
                   id="payer-house"
                   v-on:keypress="LetterNumSymbolsMask($event)" type="text"
                   placeholder="Номер будинку"
                   :class="['form-control', {invalid: ((!$v.payer.house.required && submitCheck) || (!$v.payer.house.minLength) || (!onlyLatinAndNumAndSpecials(payer.house)))}]">
            <small class="error"
                   v-if="!$v.payer.house.required && submitCheck">Вкажіть №
              будинку</small>
            <small class="error"
                   v-if="LetterMaskError || (submitCheck && !onlyLatinAndNumAndSpecials(payer.house))">Тільки
              цифри, латинські літери, кирилиця та символи "-/"</small>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="form-group">
            <label for="payer-apartment">Квартира</label>
            <input v-model="payer.apartment"
                   id="payer-apartment"
                   v-on:keypress="LetterNumSymbolsMask($event)" type="text"
                   placeholder="Квартира"
                   :class="['form-control', {invalid: ((!$v.payer.apartment.minLength) || (!onlyLatinAndNumAndSpecials(payer.apartment)))}]">
            <small class="error"
                   v-if="!$v.payer.apartment.minLength && submitCheck">Вкажіть
              № квартири</small>
            <small class="error"
                   v-if="LetterMaskError || (!onlyLatinAndNumAndSpecials(payer.apartment))">Тільки
              цифри, латинські літери, кирилиця та символи "-/"</small>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>


<style scoped lang="scss">
.form-group {
  .icon.question {
    top: 35px;
  }
  label {
    font-size: 15px;
  }
}
</style>
